import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'components';
import SubmitModal from '../../components/layout/components/submitModal';
import { isBeneficiary, isProvider, outcomes } from 'utils';
import { isEmpty, isNil } from 'lodash';
import { getLocalString, localNames } from 'utils/localisation.service';
import { handleSubmit } from 'utils';
import { submitTask, updateFormField } from 'store/forms/actions';

const FormFooter = ({ current, setCurrent, currentSubTab, steps, tabs }) => {
  const locales = useSelector(state => state.forms?.localeStrings);
  const task = useSelector(state => state.forms.task);
  const state = useSelector(state => state.forms);
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [outcome, setOutcome] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const params = useParams();
  const location = useLocation();
  const appTrack = location.pathname.includes('apptrack');

  useEffect(() => {
    // Code to run on component mount
  }, []);

  useEffect(() => {
    // Code to run when 'current' changes
  }, [current]);

  const specialActions = [
    !appTrack &&
      ['task.name.audit_objection'].includes(task?.taskName) &&
      isProvider(user?.groups) && {
        label: 'Επιστροφή στον Ωφελούμενο',
        type: 'default',
        id: 'return-btn',
        className: 'dark-grey',
        onClick: () => {
          setOutcome(outcomes.returnObjection);
          setIsVisible(true);
        },
      },
  ].filter(Boolean);

  const commonActions = [
    current !== 0 && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      id: 'prev-step-button',
      className: 'dark-grey',
      onClick: () => {
        setCurrent(current - 1);
      },
    },
    current !== (!isNil(steps) ? steps.length - 1 : tabs.length - 1) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
      type: 'primary',
      id: 'next-step-btn',
      className: 'brown-grey',
      onClick: () => {
        setCurrent(current + 1);
      },
    },
  ].filter(Boolean);

  const commonActionsSub = [
    (currentSubTab !== 0 || current !== 0) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      id: 'prev-step-button',
      className: 'dark-grey',
      onClick: () =>
        currentSubTab !== 0
          ? dispatch(
              updateFormField({
                group: 'carrier',
                key: 'currentSubTab',
                value: currentSubTab - 1,
              })
            )
          : setCurrent(current - 1),
    },
    (current !== tabs.length - 1 ||
      current !== (!isNil(steps) ? steps.length - 1 : tabs.length - 1)) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
      type: 'primary',
      id: 'next-step-btn',
      className: 'brown-grey',
      onClick: () =>
        currentSubTab !== tabs[current]?.tabsComponent.length - 1
          ? dispatch(
              updateFormField({
                group: 'carrier',
                key: 'currentSubTab',
                value: currentSubTab + 1,
              })
            )
          : setCurrent(current + 1),
    },
  ].filter(Boolean);

  return (
    <div className="form-footer">
      <SubmitModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        formKey={task.formKey}
        outcome={outcome}
        handleSubmit={() =>
          handleSubmit({
            state: { ...state },
            user: { ...user },
            dispatch,
            submitTask,
            navigate,
            setIsVisible,
            taskId: params.taskId,
            formKey: task.formKey,
            outcome,
            task,
          })
        }
      />

      {/* Divider line */}
      <div className="form-footer__divider"></div>

      {/* Wrapper to handle button alignment */}
      <div className="form-footer__actions-wrapper">
        <div className="form-footer__actions form-footer__actions--left">
          {!isEmpty(specialActions) &&
            specialActions?.map((action, index) => (
              <Button key={'special-btn-' + index} {...action} />
            ))}
        </div>
        <div className="form-footer__actions form-footer__actions--right">
          {tabs[current]?.subtabs
            ? commonActionsSub?.map((action, index) => (
                <Button key={index} {...action} />
              ))
            : commonActions?.map((action, index) => (
                <Button key={'common-btn-' + index} {...action} />
              ))}
        </div>
      </div>
    </div>
  );
};

export default FormFooter;
